import { __values } from "tslib";
var initializeServiceWorker = function () {
    //@ts-ignore
    if ("serviceWorker" in navigator && window.lturServiceWorker.activate) {
        navigator.serviceWorker
            .register('/js/serviceWorker/serviceWorker.js', { scope: '/' })
            .then(function (_) { return console.log('Registered service worker'); })
            .catch(function (e) { return console.log('Error registering: ', e); });
    }
    else if ("serviceWorker" in navigator) {
        navigator.serviceWorker.getRegistrations().then(function (registrations) {
            var e_1, _a;
            try {
                for (var registrations_1 = __values(registrations), registrations_1_1 = registrations_1.next(); !registrations_1_1.done; registrations_1_1 = registrations_1.next()) {
                    var registration = registrations_1_1.value;
                    registration.unregister();
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (registrations_1_1 && !registrations_1_1.done && (_a = registrations_1.return)) _a.call(registrations_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        });
    }
};
export default initializeServiceWorker;
